<!--
 * @Author: your name
 * @Date: 2021-09-11 10:03:19
 * @LastEditTime: 2021-09-11 10:46:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-hiprint-examplef:\学习\自学\前端开发\流程管控系统\后端管理系统\vueproject\src\views\produceDataManage\pop\planPop.vue
-->
<template>
  <el-dialog :title="title" :visible="visible">
    <el-form label-width="80px" :model="editForm" :rules="rules" ref="editForm">
      <el-form-item label="型号" prop="model_type">
        <el-input
          size="small"
          v-model="editForm.model_type"
          auto-complete="off"
          placeholder="请输入型号"
          disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="入库数量" prop="warehouse_num">
        <el-input
          size="small"
          v-model="editForm.warehouse_num"
          auto-complete="off"
          placeholder="请输入入库数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="报废数量" prop="scrap_num">
        <el-input
          size="small"
          v-model="editForm.scrap_num"
          auto-complete="off"
          placeholder="请输入报废数量"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        class="title"
        @click="submitForm"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["rowData"],
  data() {
    return {
      editForm: {},
      title: "二次处理",
      loading: false,
      visible: true,
      rules: {
        model_type: { required: true, message: "请输入型号", trigger: "blur" },
        warehouse_num: {
         
          required: true,
          message: "请输入入库数量",
          trigger: "blur",
        },
        scrap_num: {
         
          required: true,
          message: "请输入报废数量",
          trigger: "blur",
        },
      },
    };
  },
  created() {
    if (this.rowData.model_type) {
      this.editForm = {...this.rowData};
    } else {
      //   this.title="增加计划"
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submitForm() {
      this.$refs.editForm.validate((res) => {
        if (res) {
          this.editForm.type="2"
          this.$emit("save", this.editForm);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/produceDataManage/pop/secondHandle.vue